import { createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = {
  xmlns: "http://www.w3.org/2000/svg",
  width: "58",
  height: "98",
  fill: "none"
}

export function render(_ctx, _cache) {
  return (_openBlock(), _createElementBlock("svg", _hoisted_1, _cache[0] || (_cache[0] = [
    _createElementVNode("path", {
      fill: "currentColor",
      "fill-rule": "evenodd",
      d: "M32.8 15.35a8.278 8.278 0 1 1 15.9-4.612 8.278 8.278 0 0 1-15.9 4.613m4.53-14.097c-6.512 1.89-10.26 8.7-8.37 15.212 1.889 6.512 8.7 10.26 15.211 8.37 6.512-1.889 10.26-8.7 8.37-15.212-1.888-6.512-8.7-10.26-15.211-8.37M4.455 40.517a8.277 8.277 0 1 1 15.9-4.613 8.277 8.277 0 0 1-15.9 4.612m4.529-14.098c-6.512 1.89-10.26 8.7-8.37 15.212 1.889 6.512 8.7 10.26 15.212 8.37 6.512-1.889 10.26-8.7 8.37-15.212s-8.7-10.26-15.212-8.37m28.724 43.445a8.277 8.277 0 1 1 15.9-4.612 8.277 8.277 0 0 1-15.9 4.612m4.529-14.097c-6.512 1.889-10.26 8.7-8.37 15.212 1.889 6.512 8.7 10.26 15.212 8.37s10.26-8.7 8.37-15.212-8.7-10.26-15.212-8.37M10.657 77.54a8.277 8.277 0 1 0 4.612 15.9 8.277 8.277 0 0 0-4.613-15.9M1.17 88.91C-.719 82.4 3.03 75.589 9.541 73.7c6.513-1.89 13.323 1.858 15.213 8.37s-1.859 13.323-8.37 15.212C9.87 99.171 3.06 95.423 1.17 88.911",
      "clip-rule": "evenodd"
    }, null, -1)
  ])))
}
export default { render: render }